/*
 *
 *  * Copyright(c) 2021 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input } from '@angular/core';
import { AppConfigService } from '@app/common/app-config.service';
import { UtilService } from '@app/util/util.service';
import { TranslateService } from '@ngx-translate/core';
import { DataTransformationService } from '@app/common/data-transformation.service';

@Component({
  selector: 'app-multi-domain-mrn',
  templateUrl: './multi-domain-mrn.component.html',
  styleUrls: ['./multi-domain-mrn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiDomainMrnComponent {
  @Input() id;
  @Input() mrnData: any;
  @Input() showTooltip = false;
  popoverOpen = false;
  popoverOnTooltip = false;
  private window: Window;

  constructor(
    @Inject(DOCUMENT) private document,
    private cd: ChangeDetectorRef,
    private appConfigService: AppConfigService,
    private utilService: UtilService,
    private translateService: TranslateService,
    private dataTransformationService: DataTransformationService
  ) {
    this.window = this.document.defaultView;
  }

  leavePopoverBadge() {
    const popoverTimeout = this.window.setTimeout(() => {
      if (!this.popoverOnTooltip) {
        this.popoverOpen = false;
        this.cd.detectChanges();
      }
      this.window.clearTimeout(popoverTimeout);
    }, 200);
  }

  leavePopoverTooltip() {
    this.popoverOpen = false;
    this.popoverOnTooltip = false;
  }

  getDomainLabel(domainInfo) {
    if (domainInfo.system === this.appConfigService.getNHIDomainName()) {
      return this.utilService.getLocalizedNHISpecificText('patientModule.nhiLabel', this.appConfigService.getNHIType());
    } else {
      return this.translateService.instant('label.pid');
    }
  }

  getDomainValue(domainInfo) {
    if (domainInfo.system === this.appConfigService.getNHIDomainName()) {
      return this.dataTransformationService.getFormattedNHI(domainInfo.value);
    } else {
      return domainInfo.value;
    }
  }
}
